/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './scroll-top.stache';
import appContext from 'scripts/app-context';
import domUtil from 'scripts/utils/dom';

Component.extend({
    tag: 'scroll-top',
    template: template,
    leakScope: false,
    viewModel: {},
    events: {
        inserted() {
            const scrollButton = this.element.find('.c-scroll-top');
            this.updateScroll = function(event, scrollOffset) {
                scrollOffset > 100
                    ? scrollButton.fadeIn()
                    : scrollButton.fadeOut();
            }.bind(this);
            appContext.model.screen.bind('onWindowScroll', this.updateScroll);
        },

        removed() {
            appContext.model.screen.unbind('onWindowScroll', this.updateScroll);
        },

        '.c-scroll-top click'() {
            domUtil.scrollTop(0);
        },
    },
});
